class MonitorDTO {
    public Status: string
    public Message: string;
    public Name: string;
    public InitTime: Date;
    public RequestTime: Date;
    public Url: string;

    constructor() {
        this.Status = "Ok";
        this.Name = "/";
        this.InitTime = new Date();
    }

    public SetStatus = (status: MonitorStatusEnum, message: string) => {
        if (status === MonitorStatusEnum.Ok) this.Status = "Ok";
        else if (status === MonitorStatusEnum.Warning) this.Status = "Warning";
        else if (status === MonitorStatusEnum.Critical) this.Status = "Critical";
        else this.Status = "Unknown";
        this.Message = message;
    }
}

enum MonitorStatusEnum{
    Ok, Warning, Critical, Unknown
}

export {MonitorDTO, MonitorStatusEnum};


// WEBPACK FOOTER //
// ./src/app/DTO/monitorDTO.ts